import styled from 'styled-components';

export const Container = styled.button({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  cursor: 'pointer',

  border: 'none',
  marginBottom: '10rem',
  background: 'transparent',

  '&:first-of-type': {
    marginRight: '10rem',
  },

  '&:last-of-type': {
    alignSelf: 'flex-end',
  },
});

export const IconText = styled.span(({ theme }) => ({
  fontSize: theme.typography.size12,
  textAlign: 'center',
  display: 'inline-block',
}));
